import NumberField from '@admin/components/form/numberfield'
import RadioGroup from '@admin/components/form/radiogroup'
import MoneyField from '@admin/components/form/moneyfield'
import ModalPanel from '@admin/components/modal_panel'
import PropTypes from 'prop-types'
import numeral from 'numeral'
import React from 'react'

class Numeric extends React.Component {

  static propTypes = {
    defaultValue: PropTypes.object,
    code: PropTypes.string,
    comparisons: PropTypes.array,
    field: PropTypes.object,
    name: PropTypes.string,
    type: PropTypes.string,
    onCancel: PropTypes.func,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  state = {
    operator: null,
    value: ''
  }

  _handleCancel = this._handleCancel.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    const { operator } = this.state
    const { type } = this.props
    return (
      <ModalPanel { ...this._getPanel() }>
        <div className="maha-criterion-form">
          <div className="maha-criterion-form-header">
            <RadioGroup { ...this._getRadioGroup() } />
          </div>
          <div className="maha-criterion-form-body">
            <div className="maha-criterion-form-panel">
              { !_.includes(['$nkn','$kn'], operator) &&
                <div className="maha-criterion-field">
                  { type === 'numberfield' ?
                    <NumberField { ...this._getNumeric() } /> :
                    <MoneyField { ...this._getNumeric() } />
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </ModalPanel>
    )
  }

  componentDidMount() {
    const { defaultValue } = this.props
    if(defaultValue) this._handleSet(defaultValue)
  }

  componentDidUpdate(prevProps, prevState) {
    const { operator, value } = this.state
    if(operator !== prevState.operator) {
      this._handleChange()
    }
    if(value !== prevState.value) {
      this._handleChange()
    }
  }

  _getOperators() {
    const { comparisons } = this.props
    return comparisons || [
      { value: '$eq', text: 't(equals)' },
      { value: '$neq', text: 't(does not equal)' },
      { value: '$lt', text: 't(less than)' },
      { value: '$lte', text: 't(less than or equal to)' },
      { value: '$gt', text: 't(greater than)' },
      { value: '$gte', text: 't(greater than or equal to)' },
      { value: '$kn', text: 't(is known)' },
      { value: '$nkn', text: 't(is unknown)' }
    ]
  }

  _getPanel() {
    const { operator, value } = this.state
    const { name } = this.props
    return {
      title: name,
      leftItems: [
        { svg: 'chevron_left', handler: this._handleCancel }
      ],
      buttons: [{
        label: 'Add Criteria',
        color: 'blue',
        disabled: _.includes(['$eq','$nek','$lk','$nlk'], operator) && value.length === 0,
        handler: this._handleDone
      }]
    }
  }

  _getRadioGroup() {
    const options = this._getOperators()
    const { operator } = this.state
    return {
      defaultValue: operator || options[0].value,
      deselectable: false,
      options,
      onChange: this._handleUpdate.bind(this, 'operator')
    }
  }

  _getNumeric() {
    const { operator, value } = this.state
    return {
      defaultValue: value,
      disabled: _.includes(['$nkn','$kn'], operator),
      placeholder: 'Enter a value',
      onChange: _.debounce(this._handleUpdate.bind(this, 'value'), 250)
    }
  }

  _handleCancel() {
    this.props.onCancel()
  }

  _handleChange() {
    const { operator, value } = this.state
    const { code } = this.props
    this.props.onChange({
      code,
      operator,
      value,
      data: null
    })
  }

  _handleDone() {
    const { operator, type, value } = this.state
    const { code } = this.props
    this.props.onDone({
      code,
      operator,
      value,
      data: type !== 'numberfield' ? {
        text: numeral(value).format('0.00')
      } : null
    })
  }

  _handleSet(defaultValue) {
    const operator = Object.keys(defaultValue)[0]
    const value = defaultValue[operator]
    this.setState({ operator, value })
  }

  _handleUpdate(key, value) {
    this.setState({
      [key]: value
    })
  }

}

export default Numeric
